module.exports = __webpack_public_path__ + "static/crafter-panelvan-7ad1011dddde2ba2456e0462bd02196e.png";